import React from 'react';
import ReactDOM from 'react-dom';
import { motion, AnimatePresence } from "framer-motion";
import i18n from '../../i18n/i18n.js';
import { Link } from "react-router-dom";
import AppHeader from '../../components/AppHeader/AppHeader';
import { Utils, NavigateTo } from '../../Utils';
import { ReactSVG } from 'react-svg';
import { withAppContext, withModalsContext } from '../../contexts/AppContext';
import './SignIn.css'; 
import App from '../../App.js';
import PageHeader from '../../components/PageHeader/PageHeader.js';
import SystemPageLinks from '../../components/SystemPageLinks/SystemPageLinks.js';

class SignIn extends React.Component {

  settings = {};

  logged_in = 0;
  remember_me_expire = 0;
  stored_hash = '';

  emptyFormData = {
      username: '',
      email: '',
      password: '',
      chb_newsletter: 0,
      remember_me: 1,
  };

  emptyFormErrors = {
      /*  
      summary: 'Teszt hibaüzenet summary',
      banned: 'Teszt hibaüzenet banned',
      password: 'Teszt hibaüzenet password',
      email: 'Teszt hibaüzenet email',
      chb_newsletter: 'Teszt hibaüzenet chb_newsletter',
      */
      username: '',
      summary: '',
      banned: '',
      password: '',
      email: '',
      chb_newsletter: '',
  };

  constructor(props) {
      super(props);
    
      this.state = {
          formData: { ...this.emptyFormData },
          formErrors: { ...this.emptyFormErrors },
          submit_disabled: false,
          logged_in_success: 0,
          show_password_text: 0,
          display_msg: '',
      }; 

      this.display = props.display || 'login';
      this.hidden = (typeof props.hidden !== 'undefined') ? props.hidden : true;
      this.appRef = this.props.appContext.appRef;

      
  }

  show(){
    this.hidden = false;
    this.forceUpdate();
  }

  hide(){
    if(this.hidden) return;
    this.hidden = true;
    this.forceUpdate();

    if(this.props.modalsContext?.AppFooterMenuRef?.current){
      this.props.modalsContext.AppFooterMenuRef.current.deactivate_all_menu_items();
    }
  }

  componentDidMount() {
    this.logged_in = this.appRef.current.get_is_signed();

    const login_email = Utils.localSorageGetWithExpiry('login_email_' + i18n.resolvedLanguage);

    if (!!login_email)
    {
      this.state.formData.username = login_email; // sign_in
      this.state.formData.email = login_email; // lost_pw

      this.setState({formData: this.state.formData});
    }

    const searchParams = new URLSearchParams(window.location.search);
    if(searchParams.get('message') === 'otp_sent'){
          this.setState({display_msg: i18n.t('signInOneTimeCodeSent')});
    }

  }


  set_is_signed(is_signed){
    
    this.setState({logged_in_success:is_signed});
  }

  handle_submit(event) {
    event.preventDefault();
  
    this.setState({submit_disabled: true}, () => {
        this.appRef.current.login(false,this.state.formData,null,()=>{
          this.set_is_signed(1);
        },(resp)=>{
          this.setState({submit_disabled:false});
          this.get_xhr_messages(resp.error_messages);
        });
    });
  }

  get_xhr_messages(messages)
  {
      const processed_messages = {};

      if (messages) {
          Object.keys(messages).forEach((key) => {
              const error_obj = messages[key];
              const current_errors = [];

              Object.keys(error_obj).forEach((error_code) => {
                  if (error_obj[error_code]?.error_message) {
                      current_errors.push(error_obj[error_code].error_message);
                  }
              });

              processed_messages[key] = current_errors.join('<br>');
          });
      }

      this.setState({formErrors : Object.assign({ ...this.emptyFormErrors }, processed_messages)});
  }
  
  handle_change(event, formDataKey, force_value = null) {
    const formData = this.state.formData;

    formData[formDataKey] = force_value !== null ? force_value : event.target.value;

    this.setState({formData});
  }

  render() {

    const {formData, formErrors, submit_disabled } = this.state;


    if(this.state.logged_in_success==1){
      return <NavigateTo toURL="/"></NavigateTo>
    }
  
    //if (this.hidden) return  '';

    return ReactDOM.createPortal(
        <AnimatePresence>
        {!this.hidden && (
        <motion.div 
            className={`container floating_container page_sign_in ${this.display}`}
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
        >
          <div className="content">
          
              <PageHeader isHistoryBack={true} callback={() => {this.hide()}} no_close={true} title={i18n.t('signInTitle')}></PageHeader>
              
              <div className="form_wrapper">

                {this.state.display_msg.length > 0 && <div className='login-msg'>{this.state.display_msg}</div>}
                
                <form onSubmit={(e) => this.handle_submit(e)}>
                  
                    <div className={`field ${formErrors.username !== '' && formErrors.banned === '' ? "error" : ""}`}>
                        <input placeholder={i18n.t('signInEmail')} name="app_username" type="email" value={formData.username} onChange={(e) => this.handle_change(e, 'username')} />
                        {(formErrors.username.length && formErrors.banned.length === 0) ? <div className="form_error"  dangerouslySetInnerHTML={{__html: formErrors.username}}></div> : '' }
                        {(formErrors.banned.length) ? <div className="form_error banned" dangerouslySetInnerHTML={{__html: formErrors.banned}}></div> : '' }
                    </div>

                    <div className={`field password_field ${formErrors.password !== '' ? "error" : ""}`}>
                        <input placeholder={i18n.t('signInPassword')} name="app_password" type={((this.state.show_password_text===1) ? 'text' : 'password')} value={formData.password} onChange={(e) => this.handle_change(e, 'password')} /> 
                        <ReactSVG onClick={()=>this.setState({'show_password_text':Math.abs(this.state.show_password_text-1)})} className={`input_eye_icon`+((this.state.show_password_text===0) ? '_closed' : '')} src={`/assets/images/eye`+((this.state.show_password_text===0) ? '-closed' : '')+`.svg`}></ReactSVG>
                        {(formErrors.password.length) ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.password}}></div> : '' } 
                        {(formErrors.summary.length) ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.summary}}></div> : '' }
                    </div> 
  
                    <div className={`form_submit`}>
                        <input disabled={submit_disabled} className='submit_btn' type="submit" value={i18n.t('signInNext')} />
                    </div>

                    <div className={`field`}>
                      <Link  data-type="in_app" className="lost_password" to="/lost-password" onClick={() => this.hide()}>{i18n.t('signInLostPassword')}</Link>
                    </div>

                </form> 

                <Link data-type="in_app" className="account_create" to="/account_create">{i18n.t('signInRegistration')}</Link>

                <SystemPageLinks></SystemPageLinks>
              </div>

        </div>
        
      </motion.div>
      )}
      </AnimatePresence>, document.querySelector('.application_wrapper')
    );
    }
}

export default withModalsContext(withAppContext(SignIn));